import { Store } from '@/store/mainStore';
import EngineModule from '@/store/engine/modules/EngineModule';
import { v4 as uuidv4 } from 'uuid';
import { Order, OrderFlagsInput, OrderService } from '@/store/engine/openapi/generated';

type OrderProduct = {
	externalID: string;
	brandID: any;
	createdBy: string;
	manufacturerID: any;
};

export type OrderItem = {
	product: OrderProduct;
	shoeSize: number;
	shoeSizeGender: string;
	quantity: number;
	type: string;
};

type OrderData = {
	name?: { firstName?: string; lastName?: string };
	userID?: string;
	gender?: string;
	reorderOfID?: string;
	weight?: number;
};

export default class OrderModule extends EngineModule {
	constructor(s: Store) {
		super(s);
	}

	public generateOrderID(): string {
		return uuidv4();
	}

	public async getOrderFlags(orderID: string) {
		const oflags: OrderFlagsInput = {
			orderID: orderID
		};
		return OrderService.orderControllerOrderFlags(oflags).then((o) => o);
		// return this.sdk.getOrderFlags({ orderID }).then((o) => o.getOrder);
	}

	public async getOrder(orderID: string) {
		return await OrderService.orderControllerGetOrder(orderID).then((o) => o);
		//return this.sdk.getOrder({ orderID }).then((o) => o.getOrder);
	}

	public async getOrderAttachment(orderID: string, attachmentName: string) {
		return OrderService.orderControllerGetOrderAttachment(orderID, attachmentName).then((a) => a.data);
		//return await this.sdk.getOrderAttachment({ getAttachmentInput }).then((a) => a.getOrderAttachment);
	}

	public async flagsOrder(orderID: string, expertReview: boolean) {
		const orderFlagsInput = {
			orderID: orderID,
			expertReview: expertReview
		};

		return OrderService.orderControllerOrderFlags(orderFlagsInput);

		//return await this.sdk.orderFlags({ orderFlagsInput });
	}

	public async order(orderID: string, items: Array<Record<string, any>>, orderData?: OrderData) {
		const sessionID = await this.store.engine.profile.getFitstationProfile(this.store._patient.userRecordID).then((r) => r?.data?.lastValidScanningSession);

		if (!sessionID) {
			throw new Error('No session ID!');
		}

		let scans = await this.store.engine.biometric.getScans(sessionID);

		scans = [...scans.reverse()];

		const measurementData = {
			leftScanID: scans.find((s) => s.subtype === 'SCAN_SUBTYPE_FLAT_LEFT_FOOT')?.measurementID || '',
			rightScanID: scans.find((s) => s.subtype === 'SCAN_SUBTYPE_FLAT_RIGHT_FOOT')?.measurementID || ''
		};

		if (!measurementData.leftScanID && !measurementData.rightScanID) {
			throw new Error('No scans found');
		}

		const s = this.store.engine.store.getStore;

		return await OrderService.orderControllerCreateOrder({
			orderID: orderID,
			reorderOfID: this.store.order.lastOrder?.orderID === '' ? undefined : this.store.order.lastOrder?.orderID,
			firstName: orderData?.name?.firstName || this.store._patient.patientUIData.firstName,
			lastName: orderData?.name?.lastName || this.store._patient.patientUIData.lastName,
			gender: orderData?.gender || this.store._patient.patientUIData.gender === 'unknown' ? 'female' : this.store._patient.patientUIData.gender,
			weight: orderData?.weight || this.store._patient.patientUIData.weight.value || 0,
			companyID: s.companyID,
			storeID: s.storeID,
			userID: orderData?.userID || this.store._patient.userRecordID,
			sessionID,
			measurementData,
			items,
			createdBy: this.store.doctor.doctorUser?.userID ? this.store.doctor.doctorUser?.userID : '',
			deliveryOption: '',
			flags: {
				zebraID: this.store._patient.patientUIData.zebraID
			}
		}).then((o) => o);
	}
}
